import "../css/app.css";

require("./src/map")
require("./src/main")